import React, { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

/**
 * PlanCard - Expandable card showing the agent's planning steps.
 *
 * @param {string} content - Raw plan text (newline-separated steps)
 */
const PlanCard = ({ content }) => {
  const [expanded, setExpanded] = useState(false);
  const lines = (content || "").split("\n").filter(l => l.trim());

  return (
    <div className="border border-edge-border bg-surface-muted rounded-lg overflow-hidden">
      <div
        className="flex items-center justify-between px-3 py-3 sm:px-[12px] sm:py-[14px] cursor-pointer select-none"
        onClick={() => setExpanded((v) => !v)}
      >
        <p className="text-[12px] font-medium text-ink-ink dark:text-ink-white">
          {lines.length === 1 ? "1 step" : `${lines.length} steps`}
        </p>
        <span className="text-ink-gray-500 dark:text-ink-gray-400 flex-shrink-0 ml-2">
          {expanded ? <ChevronUp size={14} strokeWidth={2.5} /> : <ChevronDown size={14} strokeWidth={2.5} />}
        </span>
      </div>
      {expanded ? (
        <div className="border-t border-edge-border bg-surface-page px-3 py-3 sm:px-[12px]">
          <ol className="space-y-1 list-none m-0 p-0">
            {lines.map((line, i) => (
              <li key={i} className="flex items-start gap-2 text-[13px] leading-5 text-ink-ink dark:text-ink-white">
                <span className="flex-shrink-0 text-ink-gray-500 dark:text-ink-gray-400 w-4">{i + 1}.</span>
                <span className="min-w-0 break-words">{line.replace(/^\d+\.\s*/, "")}</span>
              </li>
            ))}
          </ol>
        </div>
      ) : null}
    </div>
  );
};

export default PlanCard;
